"use strict";

var formHasError = false;

function selectProfession(useDefault) {
  var arr = [];

  $("#product_profession_id").val("");

  if (useDefault) {
    $("#product_profession_id").attr("data-selected", -1);
  }

  $("#js-boxes-pp input[type=checkbox]").each(function(i, item) {
    var obj = {
      value: $(item)
        .parent()
        .find("input")
        .attr("data-id"),
      text: $(item)
        .parent()
        .text()
        .trim(),
      checked: $(item).is(":checked"),
      selected:
        $(item)
          .parent()
          .find("input")
          .attr("data-id") == $("#product_profession_id").attr("data-selected")
    };
    arr.push(obj);
  });

  const sel = $("#product_profession_id");
  const defaultOption = $(sel).attr("data-default-option");
  $(sel).html(`<option value='' data-id="-1" > ${defaultOption} </option>`);

  $(arr).each(function(i, item) {
    item.checked &&
      sel.append(
        $("<option>")
          .val(this.value)
          .text(this.text)
          .attr("selected", item.selected)
      );
  });
}

function validateCheckboxes(runValidations = true) {
  if ($("#js-services").hasClass("has-errors")) {
    runValidations = true;
  }

  if ($("#js-events").hasClass("has-errors")) {
    runValidations = true;
  }

  var countboxes = $("#js-boxes input[type=checkbox]:checked").length;
  $("#js-box-count span").html(countboxes);

  var countpp = $("#js-boxes-pp input[type=checkbox]:checked").length;
  $("#js-box-count-pp span").html(countpp);

  var count = $("#js-boxes-mi input[type=checkbox]:checked").length;
  $("#js-box-count-mi span").html(count);

  var countlang = $("#js-boxes-languages input[type=checkbox]:checked").length;

  var countstyles = $("#js-boxes-styles input[type=checkbox]:checked").length;

  var countevents = $("#js-boxes-events input[type=checkbox]:checked").length;

  // run validations
  runValidations &&
    countpp == 0 &&
    $("#js-boxes-pp input[type=checkbox]")
      .parent()
      .addClass("is-invalid") &&
    $("#product_profession_id").addClass("is-invalid");
  runValidations &&
    countpp > 0 &&
    $("#js-boxes-pp input[type=checkbox]")
      .parent()
      .removeClass("is-invalid");
  runValidations &&
    countpp > 0 &&
    $("#product_profession_id").attr("data-selected") != "" &&
    $("#product_profession_id").removeClass("is-invalid");

  runValidations &&
    countboxes == 0 &&
    $("#js-boxes input[type=checkbox]")
      .parent()
      .addClass("is-invalid");
  runValidations &&
    countboxes > 0 &&
    $("#js-boxes input[type=checkbox]")
      .parent()
      .removeClass("is-invalid");

  runValidations &&
    count == 0 &&
    $("#js-boxes-mi input[type=checkbox]")
      .parent()
      .addClass("is-invalid");
  runValidations &&
    count > 0 &&
    $("#js-boxes-mi input[type=checkbox]")
      .parent()
      .removeClass("is-invalid");

  runValidations &&
    countlang == 0 &&
    $("#js-boxes-languages input[type=checkbox]")
      .parent()
      .addClass("is-invalid");
  runValidations &&
    countlang > 0 &&
    $("#js-boxes-languages input[type=checkbox]")
      .parent()
      .removeClass("is-invalid");

  runValidations &&
    countstyles == 0 &&
    $("#js-boxes-styles input[type=checkbox]")
      .parent()
      .addClass("is-invalid");
  runValidations &&
    countstyles > 0 &&
    $("#js-boxes-styles input[type=checkbox]")
      .parent()
      .removeClass("is-invalid");

  runValidations &&
    countevents == 0 &&
    $("#js-boxes-events input[type=checkbox]")
      .parent()
      .addClass("is-invalid") &&
    $(".is-invalid.with-error").css("display", "block");
  runValidations &&
    countevents > 0 &&
    $("#js-boxes-events input[type=checkbox]")
      .parent()
      .removeClass("is-invalid") &&
    $(".is-invalid.with-error").css("display", "none");

  $("#js-boxes-pp input[type=checkbox]:not(:checked)").attr(
    "disabled",
    countpp >= 3
  );
  $("#js-boxes input[type=checkbox]:not(:checked)").attr(
    "disabled",
    countboxes >= 20
  );
  $("#js-boxes-mi input[type=checkbox]:not(:checked)").attr(
    "disabled",
    count >= 10
  );
}

function onLoad() {
  validateCheckboxes(false);
  selectProfession(false);

  $("#js-boxes input[type=checkbox]").each(function() {
    $(this).on("change", validateCheckboxes);
  });

  $("#js-boxes-mi input[type=checkbox]").each(function() {
    $(this).on("change", validateCheckboxes);
  });

  $("#js-boxes-pp input[type=checkbox]").each(function() {
    $(this).on("change", validateCheckboxes);
    $(this).on("change", function() {
      selectProfession(true);
    });
  });

  $("#js-boxes-languages input[type=checkbox]").each(function() {
    $(this).on("change", validateCheckboxes);
  });

  $("#js-boxes-styles input[type=checkbox]").each(function() {
    $(this).on("change", validateCheckboxes);
  });

  $("#js-boxes-events input[type=checkbox]").each(function() {
    $(this).on("change", validateCheckboxes);
  });

  $(function() {
    var input = $("input[type=checkbox]");
    input.each(function() {
      if ($(this).prop("disabled")) {
        $(this)
          .parent()
          .addClass("form-check-label--is-disabled");
      }
    });

    input.each(function(i, item) {
      input.change(function() {
        if ($(item).prop("disabled")) {
          $(item)
            .parent()
            .addClass("form-check-label--is-disabled");
        } else {
          $(item)
            .parent()
            .removeClass("form-check-label--is-disabled");
        }
      });
    });
  });

  $("#js-btn-contact-submit").on("click", function() {
    if ($("#text").val() != "") {
      $("#contact-form-profile").submit();
    } else {
      // TODO replace with the form-status component, once the price branch is
      // branch.
      $("#js-fehler").html(
        '<div class="col-lg-12 alert alert-danger" role="alert"><p class="mb-0">Fehler:<br>Bitte text angeben.</p></div>'
      );
      formHasError = true;
    }
  });

  $("#text").on("keydown", function() {
    if (!formHasError) return;
    $("#js-fehler").html("");
  });

  // handle the birthday toggle
  $("#js-birthday").toggle($($("#event_types_2").get(0)).is(":checked"));
  $("#js-toggle").on("click", function(e) {
    //  perform the changes only if the checkbox is clicked.
    if ($(e.target).attr("id") == "event_types_2") {
      $("#js-birthday").slideToggle();
    }
  });
}

module.exports = {
  onLoad
};



// WEBPACK FOOTER //
// ./resources/js/checkboxes.js